import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { List, X, Compass, Barbell, Trophy, Quotes, MapTrifold, House, Phone } from "@phosphor-icons/react";

const LINKS = [
  { href: "#quiz", label: "Find My Path", icon: Compass },
  { href: "#services", label: "Packages", icon: Barbell },
  { href: "#transformations", label: "Results", icon: Trophy },
  { href: "#testimonials", label: "Testimonials", icon: Quotes },
  { href: "#locations", label: "Bay Area", icon: MapTrifold },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? "backdrop-blur-xl bg-black/60 border-white/10" : "bg-transparent border-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-brand-link" className="shrink-0">
          <img
            src="https://customer-assets-0z36b82j.emergentagent.net/job_existfit-portal/artifacts/c41920wx_ExistFitLogo.webp"
            alt="Exist Fit"
            className="h-9 sm:h-10 w-auto"
          />
        </a>
        <div className="hidden lg:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="relative text-lg font-bold text-[#D4D4D8] tracking-wide transition-colors duration-300 hover:text-[#D4AF37] hover:[text-shadow:0_0_12px_rgba(212,175,55,0.8)] after:absolute after:left-0 after:-bottom-2 after:h-[2px] after:w-0 after:bg-[#D4AF37] after:transition-all after:duration-300 hover:after:w-full"
            >
              {l.label}
            </a>
          ))}
        </div>
        <div className="hidden lg:flex items-center gap-5">
          <Link
            to="/portal-login"
            data-testid="nav-portal-login-link"
            className="text-lg font-bold text-[#D4D4D8] tracking-wide transition-colors duration-300 hover:text-[#D4AF37] hover:[text-shadow:0_0_12px_rgba(212,175,55,0.8)]"
          >
            Client Login
          </Link>
          <a
            href="#contact"
            data-testid="nav-book-call-button"
            className="bg-[#D4AF37] text-black text-base font-bold tracking-wide px-8 py-3.5 rounded-full shadow-[0_0_25px_rgba(212,175,55,0.55)] hover:shadow-[0_0_40px_rgba(212,175,55,0.9)] hover:bg-white hover:scale-105 transition-all duration-300"
          >
            Book Free Call
          </a>
        </div>
        <button
          data-testid="nav-mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden flex items-center justify-center w-12 h-12 rounded-full border-2 border-[#D4AF37] text-[#D4AF37] shadow-[0_0_18px_rgba(212,175,55,0.5)] hover:shadow-[0_0_28px_rgba(212,175,55,0.85)] transition-shadow duration-300"
        >
          {open ? <X size={26} weight="bold" /> : <List size={26} weight="bold" />}
        </button>
      </nav>
      {open && (
        <div className="lg:hidden bg-black/95 border-t-2 border-l-2 border-[#D4AF37]/60 shadow-[0_0_40px_rgba(212,175,55,0.15)] pl-10 pr-6 py-8 flex flex-col gap-6">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 text-xl font-bold text-white tracking-wide transition-colors duration-200 active:text-[#D4AF37] hover:text-[#D4AF37]"
            >
              <l.icon size={22} weight="bold" className="text-[#D4AF37] shrink-0" />
              {l.label}
            </a>
          ))}
          <Link
            to="/portal-login"
            onClick={() => setOpen(false)}
            className="w-full flex items-center justify-center gap-2 text-center border-2 border-[#D4AF37] text-[#D4AF37] text-lg font-bold tracking-wide px-6 py-3.5 rounded-full shadow-[0_0_20px_rgba(212,175,55,0.4)] hover:bg-[#D4AF37]/10 transition-colors duration-300"
          >
            <House size={20} weight="bold" /> Client Login
          </Link>
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            data-testid="nav-mobile-book-call-button"
            className="w-full flex items-center justify-center gap-2 text-center bg-[#D4AF37] text-black text-lg font-bold tracking-wide px-6 py-3.5 rounded-full shadow-[0_0_25px_rgba(212,175,55,0.6)] hover:shadow-[0_0_40px_rgba(212,175,55,0.9)] transition-shadow duration-300"
          >
            <Phone size={20} weight="bold" /> Book Free Call
          </a>
        </div>
      )}
    </header>
  );
}
